/**
 * Pins that share a grid cell form a stack; cells within `km` of each other (connected
 * neighbours, transitively) merge so near-overlapping icons share one chooser.
 * Returns arrays of { shipment, pin }. Used by the map markers AND the waiting panel, so a
 * panel always sees exactly the stack the user clicked.
 */
export function groupPinStacks(shipments, pinLatLng, cellKey, km = 2) {
  const groups = new Map();
  (shipments || []).forEach((s) => {
    const pin = pinLatLng(s);
    if (!pin) return;
    const key = cellKey(pin[0], pin[1]);
    if (!key) return;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push({ shipment: s, pin });
  });
  const entries = [...groups.entries()];
  const parent = entries.map((_, i) => i);
  const find = (i) => (parent[i] === i ? i : (parent[i] = find(parent[i])));
  const repPin = (items) => items[0]?.pin;
  for (let i = 0; i < entries.length; i += 1) {
    for (let j = i + 1; j < entries.length; j += 1) {
      const a = repPin(entries[i][1]);
      const b = repPin(entries[j][1]);
      if (!a || !b) continue;
      const dLat = (a[0] - b[0]) * 111.32;
      const cos = Math.max(0.2, Math.cos((a[0] * Math.PI) / 180));
      const dLng = (a[1] - b[1]) * 111.32 * cos;
      if (Math.hypot(dLat, dLng) <= km) {
        const ri = find(i);
        const rj = find(j);
        if (ri !== rj) parent[rj] = ri;
      }
    }
  }
  const merged = new Map();
  entries.forEach(([, items], i) => {
    const root = find(i);
    if (!merged.has(root)) merged.set(root, []);
    merged.get(root).push(...items);
  });
  return [...merged.entries()].map(([root, items]) => ({ root, items }));
}
